export default __webpack_public_path__ + "static/banner-howitworks-61737ad111e3979bcd9dc44fe8029eb9.png";